/* STELBO — mod prezentare (snippets/stelbo-showcase.liquid).

   Orice element cu `data-st-soon` (butoanele de cumparare si iconita de cos)
   nu mai face nimic la apasare, in afara de tooltipul de langa el.

   Ascultatorii stau pe document, in faza de CAPTURE: ruleaza inaintea celor
   Dawn (product-form, modal-opener, quick-add, cart-drawer), care asculta pe
   elementul tinta. stopImmediatePropagation() opreste evenimentul inainte sa
   ajunga la ei, iar preventDefault() opreste navigarea si trimiterea
   formularului. A doua bariera e in Dawn insusi: product-form.js refuza
   trimiterea cat timp butonul are aria-disabled="true", pus din Liquid. */

(() => {
  const tip = document.getElementById('StSoonTip');
  const live = document.getElementById('StSoonLive');
  if (!tip || !live) return;

  const GAP = 10; // distanta tooltip - buton
  const EDGE = 12; // distanta minima fata de marginile ecranului
  const ARROW_INSET = 18; // sageata nu intra in colturile rotunjite
  const DURATION = 4500;
  const SCROLL_TOLERANCE = 24; // un tap pe telefon misca pagina cativa px

  let current = null;
  let timer = 0;
  let scrollAtOpen = 0;

  const topLimit = () => {
    const bar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--st-bar-h')) || 0;
    return bar + EDGE;
  };

  // Deasupra butonului daca incape (sub bara fixa de sus), altfel dedesubt.
  // Pe orizontala: centrat pe buton, dar tinut in ecran; sageata ramane
  // indreptata spre centrul butonului chiar cand tooltipul e impins lateral.
  const position = (trigger) => {
    const r = trigger.getBoundingClientRect();
    const w = tip.offsetWidth;
    const h = tip.offsetHeight;
    const vw = document.documentElement.clientWidth;

    const above = r.top - GAP - h >= topLimit();
    const center = r.left + r.width / 2;
    const left = Math.min(Math.max(center - w / 2, EDGE), vw - EDGE - w);
    const arrowX = Math.min(Math.max(center - left, ARROW_INSET), w - ARROW_INSET);

    tip.dataset.placement = above ? 'top' : 'bottom';
    tip.style.left = `${Math.round(left)}px`;
    tip.style.top = `${Math.round(above ? r.top - GAP - h : r.bottom + GAP)}px`;
    tip.style.setProperty('--st-soon-arrow-x', `${Math.round(arrowX)}px`);
  };

  const hide = () => {
    if (!current) return;
    clearTimeout(timer);
    current = null;
    tip.classList.remove('is-open');
    live.textContent = '';
  };

  const show = (trigger) => {
    clearTimeout(timer);

    // Alt buton cat timp tooltipul e deschis: se reia de la zero, ca
    // animatia sa porneasca din noul punct, nu sa sara acolo.
    if (current && current !== trigger) {
      tip.classList.remove('is-open');
      void tip.offsetWidth;
    }

    current = trigger;
    position(trigger);
    tip.classList.add('is-open');
    scrollAtOpen = window.scrollY;

    // Golire + scriere in cadrul urmator: altfel un al doilea click cu
    // acelasi text nu ar mai fi anuntat.
    live.textContent = '';
    requestAnimationFrame(() => {
      live.textContent = live.dataset.message;
    });

    timer = setTimeout(hide, DURATION);
  };

  const block = (event, trigger) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    show(trigger);
  };

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest?.('[data-st-soon]');
      if (trigger) return block(event, trigger);
      hide();
    },
    true
  );

  // Plasa de siguranta pentru form.requestSubmit() apelat din cod: nu trece
  // prin click. (Enter intr-un camp trece — browserul simuleaza un click pe
  // butonul de submit, prins mai sus.)
  document.addEventListener(
    'submit',
    (event) => {
      const trigger = event.submitter?.closest('[data-st-soon]') || event.target.querySelector('[type="submit"][data-st-soon]');
      if (trigger) block(event, trigger);
    },
    true
  );

  // Space pe un link cu role="button" (iconita de cos, cand cart_type e
  // drawer) e tratat de Dawn pe keydown, nu pe click.
  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key === 'Escape') return hide();
      if (event.key !== ' ') return;
      const trigger = event.target.closest?.('a[data-st-soon]');
      if (trigger) block(event, trigger);
    },
    true
  );

  // De aici preia showcase-ul; garda inline din theme.liquid se retrage.
  window.stSoonReady = true;

  // La Inapoi (bfcache) pagina revine cum a fost lasata: fara tooltip deschis.
  window.addEventListener('pagehide', () => hide());

  window.addEventListener(
    'scroll',
    () => {
      if (current && Math.abs(window.scrollY - scrollAtOpen) > SCROLL_TOLERANCE) hide();
    },
    { passive: true }
  );

  window.addEventListener('resize', hide);
})();
